import { showSuccess } from '@calendly/alert'
import { I18n } from '@calendly/i18n'

import { rootApi } from 'root-api'

const updateSingleUseLinkCacheData = ({ api, state, dispatch, data }) => {
  api.util.selectInvalidatedBy(state, [{ type: 'SINGLE-USE-LINKS', id: data.id }]).forEach(
    ({ endpointName, originalArgs }) => {
      if (endpointName === 'fetchSingleUseLinkData') {
        dispatch(
          api.util.updateQueryData('fetchSingleUseLinkData', originalArgs, (draft) => {
            if (!draft?.results) return

            const existingIndex = draft.results.findIndex((link) => link.id === data.id)

            if (existingIndex !== -1) {
              draft.results[existingIndex] = data
            } else {
              draft.results.unshift(data)
            }
          })
        )
      } else if (endpointName === 'fetchSingleUseLink') {
        dispatch(
          api.util.updateQueryData('fetchSingleUseLink', originalArgs, (draft) => ({ ...draft, ...data }))
        )
      }
    }
  )
}

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    createSingleUseLink: build.mutation({
      query: (data) => ({
        url: '/api/shares',
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        { type: 'SINGLE-USE-LINKS', id: 'SINGLE-USE-LINKS-PARTIAL-LIST' },
        'EMPTY_STATES_ACTIVATION_DATA'
      ],
      extraOptions: {
        onSuccess: (response, { dispatch }) => {
          dispatch(showSuccess(I18n.t('publisher.scheduling.single_use_links.flash.create_success')))
        }
      }
    }),
    createMultiHostSingleUseLink: build.mutation({
      query: (data) => ({
        url: '/api/event_type_single_use_links',
        method: 'POST',
        data: { event_type_single_use_link: data },
      }),
      invalidatesTags: [
        { type: 'SINGLE-USE-LINKS', id: 'SINGLE-USE-LINKS-PARTIAL-LIST' },
        'EMPTY_STATES_ACTIVATION_DATA'
      ],
      extraOptions: {
        onSuccess: (_, { dispatch }) => {
          dispatch(showSuccess(I18n.t('publisher.scheduling.single_use_links.flash.create_success')))
        }
      }
    }),
    updateSingleUseLink: build.mutation({
      query: ({ shareUuid, ...data }) => ({
        url: `/api/shares/${shareUuid}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['EMPTY_STATES_ACTIVATION_DATA'],
      extraOptions: {
        onSuccess: (response, { dispatch, getState }) => {
          const state = getState()
          updateSingleUseLinkCacheData({ api, state, dispatch, data: response })
          dispatch(showSuccess(I18n.t('publisher.scheduling.single_use_links.flash.update_success')))
        }
      }
    })
  })
})

export const {
  useCreateSingleUseLinkMutation,
  useCreateMultiHostSingleUseLinkMutation,
  useUpdateSingleUseLinkMutation,
} = api
